import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, FileText, Rss, Eye, Settings } from 'lucide-react';
import { useI18n } from '../../lib/i18n';

export default function AdminMobileBottomNav() {
  const { pathname } = useLocation();
  const { t } = useI18n();
  const items = [
    { to: '/admin', icon: LayoutDashboard, label: t('admin.nav.dashboard', 'Painel') },
    { to: '/admin/articles', icon: FileText, label: t('admin.nav.articles', 'Artigos') },
    { to: '/admin/rss', icon: Rss, label: 'RSS' },
    { to: '/admin/preview-home', icon: Eye, label: t('admin.nav.preview_home', 'Preview') },
    { to: '/admin/settings', icon: Settings, label: t('admin.nav.settings', 'Config') },
  ];

  return (
    <nav
      className="lg:hidden mobile-fixed-nav border-t border-white/10 bg-[#0A0A0A]/95 backdrop-blur-xl"
      style={{ paddingBottom: 'max(6px, env(safe-area-inset-bottom))' }}
      data-testid="admin-mobile-bottom-nav"
    >
      <div className="grid grid-cols-5">
        {items.map((item) => {
          const Icon = item.icon;
          const active = pathname === item.to || (item.to !== '/admin' && pathname.startsWith(item.to));
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center py-2 gap-1 text-[10px] transition-colors ${
                active ? 'text-[#E63946]' : 'text-gray-400'
              }`}
            >
              <Icon size={18} />
              <span className="font-semibold uppercase tracking-[0.08em]">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
